export const EMAIL_LOOKUP = `Vielen Dank! Bitte überprüfen Sie Ihre E-mails und bestätigen Sie das Formular!`;

export const ERROR_TEXT = 'Etwas ist schiefgelaufen, bitte probieren sie es später nocheinmal.'